module.exports = __webpack_public_path__ + "img/3fl-l30b.prt.4d2b121c.jpg";